import * as React from 'react';
import { connect } from 'react-redux';

import BaseReportingPage from '../base/BaseReportingPage';
import PageHeading from 'components/page/page-heading/PageHeading';

import SentimentAnalysis from 'modules/admin/components/sentiment-analysis/SentimentAnalysis';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./sentiment-analysis-page.i18n.json'));

import type { Campaign, Params } from 'types';

type StateProps = {
  campaign: Campaign
};

type OwnProps = {
  params: Params
};

type Props = OwnProps & StateProps;

const SentimentAnalysisPage = (
  {
    params,
    campaign
  }: Props
): JSX.Element => (
  <BaseReportingPage
    headline={__t('sentiment_analysis_page.page_headline')}
    params={params}
  >
    <div className="content-metrics-page__heading">
      <PageHeading
        heading={__t('sentiment_analysis_page.page_heading')}
        color="light"
        size="h1"
        margin="none"
      />
    </div>
    {
      campaign && campaign.id && (
        <SentimentAnalysis
          campaignId={campaign.id}
        />
      )
    }
  </BaseReportingPage>
);

const mapStateToProps = ({ campaignBrief }): StateProps => ({
  campaign: campaignBrief.brief
});

export default connect(mapStateToProps)(SentimentAnalysisPage);
